import { GraphEdge, GraphVertex } from '../types';
import { getPackId } from '../utils/packUtils';
import { Pack } from './packVertices';

const convertPackToVertex = (p: Pack): GraphVertex => ({
  id: getPackId(p),
  isPack: true,
  entity: {
    displayName: `${p.type} X ${p.packedVerticesIds.length}`,
    _type: [p.type],
    _class: [p.class],
  } as any,
});

const convertPackToEdge = (p: Pack): GraphEdge => ({
  id: getPackId(p),
  toVertexId: getPackId(p),
  fromVertexId: p.parentVertexId,
  relationship: { displayName: 'HAS' },
});

const rewriteEdgeTargetsForPack = (
  pack: Pack,
  edges: GraphEdge[]
): GraphEdge[] => {
  return edges.map((e) => {
    // If an edge originates from a packed vertex, point the edge to to the pack id
    if (pack.packedVerticesIds.includes(e.toVertexId)) {
      return { ...e, toVertexId: getPackId(pack), toPack: pack };
    } else if (pack.packedVerticesIds.includes(e.fromVertexId)) {
      return { ...e, fromVertexId: getPackId(pack), fromPack: pack };
    } else {
      return e;
    }
  });
};

const uniqueEdge = (edge: GraphEdge, index: number, edges: GraphEdge[]) =>
  edges.findIndex(
    (e) =>
      edge.fromVertexId === e.fromVertexId && edge.toVertexId === e.toVertexId
  ) === index;

const getVerticesWithPacks = (
  initialVertices: GraphVertex[],
  packs: Pack[]
) => {
  let vertices = initialVertices;
  const childVerticesToRemove = packs.flatMap((p) => p.packedVerticesIds);
  vertices = vertices.filter((v) => childVerticesToRemove.indexOf(v.id) === -1);
  vertices = vertices.concat(packs.map(convertPackToVertex));
  return vertices;
};

const getEdgesMappedWithPacks = (initialEdges: GraphEdge[], packs: Pack[]) => {
  let edges = initialEdges;

  packs.forEach((p) => {
    edges = rewriteEdgeTargetsForPack(p, edges);
  });

  // If an edge points to a vertex in a pack, remove it
  edges = edges.concat(packs.map(convertPackToEdge));
  edges = edges.filter(uniqueEdge);

  return edges;
};

const remapVerticesAndEdgesWithPacks = (
  initialVertices: GraphVertex[],
  initialEdges: GraphEdge[],
  packs: Pack[]
): { vertices: GraphVertex[]; edges: GraphEdge[] } => {
  return {
    vertices: getVerticesWithPacks(initialVertices, packs),
    edges: getEdgesMappedWithPacks(initialEdges, packs),
  };
};

export default remapVerticesAndEdgesWithPacks;
